import {
  Box,
  Checkbox,
  Collapse,
  FormControlLabel,
  IconButton,
  Tooltip,
} from "@mui/material";
import MessageContent from "./MessageContent";

const ChevronIcon = ({ expanded }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d={expanded ? "M6 15l6-6 6 6" : "M6 9l6 6 6-6"}
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MessageCard = ({
  message,
  expanded,
  dismissed,
  onToggleExpand,
  onDismissChange,
}) => {
  const titleId = `edsimsV2-message-title-${message.id}`;

  return (
    <Box className="edsimsV2-message-card" component="article">
      <Box className="edsimsV2-message-card-header">
        <Box className="edsimsV2-message-card-heading">
          <i
            className="fas fa-bullhorn edsimsV2-message-card-icon"
            aria-hidden="true"
          />
          <h3 id={titleId} className="edsimsV2-message-card-title">
            {message.title}
          </h3>
        </Box>
        <Tooltip title={expanded ? "Collapse" : "Expand"}>
          <IconButton
            className="edsimsV2-message-expand"
            onClick={() => onToggleExpand(message.id)}
            aria-expanded={expanded}
            aria-controls={`edsimsV2-message-body-${message.id}`}
            aria-label={expanded ? "Collapse message" : "Expand message"}
            size="small"
          >
            <ChevronIcon expanded={expanded} />
          </IconButton>
        </Tooltip>
      </Box>

      <Collapse in={expanded} timeout={180}>
        <Box
          id={`edsimsV2-message-body-${message.id}`}
          className="edsimsV2-message-card-body"
          aria-labelledby={titleId}
        >
          <MessageContent
            content={message.content}
            fallback={message.description}
          />
          <FormControlLabel
            className="edsimsV2-message-dismiss"
            control={
              <Checkbox
                checked={dismissed}
                onChange={(event) =>
                  onDismissChange(message.id, event.target.checked)
                }
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    event.preventDefault();
                    onDismissChange(message.id, !dismissed);
                  }
                }}
                color="primary"
              />
            }
            label="Don't show this message again"
          />
        </Box>
      </Collapse>
    </Box>
  );
};

export default MessageCard;
